[
   { "source": "Adult-only property", "display": "Adult Only", "hideIf": [] },
   { "source": "Airport transfer", "display": "Airport Transfer", "hideIf": ["Shuttle"] },
   { "source": "Bar", "display": "Bar", "hideIf": [] },
   { "source": "Alcohol", "display": "Bar", "hideIf": ["Bar"] },
   { "source": "BBQ facilities", "display": "BBQ Facilities", "hideIf": [] },
   {
      "source": "Full american breakfast",
      "display": "Breakfast",
      "hideIf": ["Free Breakfast", "Breakfast Buffet", "Continental Breakfast", "Breakfast"]
   },
   { "source": "Breakfast service", "display": "Breakfast", "hideIf": ["Free Breakfast", "Breakfast Buffet", "Continental Breakfast", "Breakfast"] },
   {
      "source": "Restaurant breakfast",
      "display": "Breakfast",
      "hideIf": ["Free Breakfast", "Breakfast Buffet", "Continental Breakfast"]
   },
   { "source": "Western breakfast", "display": "Breakfast", "hideIf": ["Free Breakfast", "Breakfast Buffet", "Continental Breakfast", "Breakfast"] },
   {
      "source": "A la carte breakfast",
      "display": "Breakfast",
      "hideIf": ["Free Breakfast", "Breakfast Buffet", "Continental Breakfast", "Breakfast"]
   },
   { "source": "Breakfast [buffet]", "display": "Breakfast Buffet", "hideIf": ["Free Breakfast", "Continental Breakfast"] },
   { "source": "Xerox/fax in business center", "display": "Business Center", "hideIf": ["Business Center"] },
   { "source": "Computer station", "display": "Business Center", "hideIf": ["Business Center"] },
   { "source": "Free use of business areas", "display": "Business Center", "hideIf": [] },
   { "source": "Coffee shop", "display": "Coffee Shop", "hideIf": [] },
   { "source": "Concierge", "display": "Concierge", "hideIf": [] },
   { "source": "Breakfast [continental]", "display": "Continental Breakfast", "hideIf": ["Free Breakfast"] },
   { "source": "Gym/fitness", "display": "Fitness Center", "hideIf": [] },
   { "source": "Badminton court", "display": "Fitness Center", "hideIf": ["Fitness Center"] },
   { "source": "Yoga room", "display": "Fitness Center", "hideIf": ["Fitness Center"] },
   { "source": "Fitness club privileges", "display": "Fitness Center", "hideIf": ["Fitness Center"] },
   { "source": "Free bottled water", "display": "Free Bottled Water", "hideIf": [] },
   { "source": "Breakfast [free]", "display": "Free Breakfast", "hideIf": [] },
   { "source": "Free laundry service", "display": "Free Laundry Service", "hideIf": [] },
   { "source": "Car park [free of charge]", "display": "Free Parking", "hideIf": [] },
   { "source": "Free Wi-Fi in all rooms!", "display": "Free Wi-Fi", "hideIf": ["Free Wi-Fi"] },
   { "source": "Wi-Fi [free]", "display": "Free Wi-Fi", "hideIf": [] },
   { "source": "Internet", "display": "Internet", "hideIf": ["Free Wi-Fi"] },
   { "source": "Internet services", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "Internet access – wireless", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "Internet [LAN]", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "Internet access – LAN", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "Wi-Fi [charges apply]", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "LAN Internet in room [free]", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "Wi-Fi in public areas", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "Gift/souvenir shop", "display": "Gift Shop", "hideIf": [] },
   { "source": "Mini golf course", "display": "Golf", "hideIf": [] },
   { "source": "Golf course (within 3 km)", "display": "Golf", "hideIf": ["Golf"] },
   { "source": "Happy hour", "display": "Happy hour", "hideIf": [] },
   { "source": "Hot tub", "display": "Hot Tub", "hideIf": [] },
   { "source": "Kids club", "display": "Kids Club", "hideIf": [] },
   { "source": "Laundry service", "display": "Laundry", "hideIf": ["Free Laundry Service"] },
   { "source": "Car park [on-site]", "display": "Parking", "hideIf": ["Free Parking"] },
   { "source": "Car park [charges apply]", "display": "Parking", "hideIf": ["Free Parking", "Parking"] },
   { "source": "On-site accessible self parking", "display": "Parking", "hideIf": ["Free Parking", "Parking"] },
   { "source": "Parking spaces for cars self-parking facility", "display": "Parking", "hideIf": ["Free Parking"] },
   { "source": "Pets allowed", "display": "Pets Allowed", "hideIf": [] },
   { "source": "Pets allowed for free", "display": "Pets Allowed", "hideIf": ["Pets Allowed"] },
   { "source": "Cat-friendly", "display": "Pets Allowed", "hideIf": ["Pets Allowed"] },
   { "source": "Dog-friendly", "display": "Pets Allowed", "hideIf": ["Pets Allowed"] },
   { "source": "Pet-friendly [charges apply]", "display": "Pets Allowed", "hideIf": ["Pets Allowed"] },
   { "source": "Pets allowed in room", "display": "Pets Allowed", "hideIf": ["Pets Allowed"] },
   { "source": "Playground", "display": "Playground", "hideIf": [] },
   { "source": "Poolside bar", "display": "Poolside Bar", "hideIf": [] },
   { "source": "Private beach", "display": "Private Beach", "hideIf": [] },
   { "source": "Restaurants", "display": "Restaurant", "hideIf": [] },
   { "source": "A la carte in restaurant", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Restaurant [halal]", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Buffet in restaurant", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Restaurant [kosher]", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Restaurant dinner", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Restaurant lunch", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Salad in restaurant", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Soup in restaurant", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Asian cuisine in restaurant", "display": "Restaurant", "hideIf": ["Restaurant"] },
   { "source": "Room service", "display": "Room Service", "hideIf": [] },
   { "source": "Room service [24-hour]", "display": "Room Service", "hideIf": ["Room Service"] },
   { "source": "Shared kitchen", "display": "Shared Kitchen", "hideIf": [] },
   { "source": "Shops", "display": "Shops", "hideIf": [] },
   { "source": "Shuttle service", "display": "Shuttle", "hideIf": [] },
   { "source": "Snack bar", "display": "Snack Bar", "hideIf": [] },
   { "source": "Massage", "display": "Spa", "hideIf": ["Spa"] },
   { "source": "Spa", "display": "Spa", "hideIf": [] },
   { "source": "Spa/sauna", "display": "Spa", "hideIf": ["Spa"] },
   { "source": "Sauna", "display": "Spa", "hideIf": ["Spa"] },
   { "source": "Steamroom", "display": "Spa", "hideIf": ["Spa"] },
   { "source": "Swimming pool", "display": "Swimming Pool", "hideIf": [] },
   { "source": "Swimming pool [outdoor]", "display": "Swimming Pool", "hideIf": ["Swimming Pool"] },
   { "source": "Pool facilities", "display": "Swimming Pool", "hideIf": ["Swimming Pool"] },
   { "source": "Swimming pool [kids]", "display": "Swimming Pool", "hideIf": ["Swimming Pool"] },
   { "source": "Swimming pool [indoor]", "display": "Swimming Pool", "hideIf": ["Swimming Pool"] },
   { "source": "Swimming pool [direct access]", "display": "Swimming Pool", "hideIf": ["Swimming Pool"] },
   { "source": "Valet parking", "display": "Valet parking", "hideIf": [] },
   { "source": "English", "display": "", "hideIf": [] },
   { "source": "Italian", "display": "", "hideIf": [] },
   { "source": "Portuguese", "display": "", "hideIf": [] },
   { "source": "Spanish", "display": "", "hideIf": [] },
   { "source": "Wheelchair accessible", "display": "", "hideIf": [] },
   { "source": "Wi-Fi in public areas", "display": "Internet", "hideIf": ["Free Wi-Fi", "Internet"] },
   { "source": "Canoeing", "display": "", "hideIf": [] },
   { "source": "Diving", "display": "", "hideIf": [] },
   { "source": "Fishing", "display": "", "hideIf": [] },
   { "source": "Game room", "display": "", "hideIf": [] },
   { "source": "Hiking", "display": "", "hideIf": [] },
   { "source": "Karaoke", "display": "", "hideIf": [] },
   { "source": "On-site entertainment", "display": "", "hideIf": [] },
   { "source": "Pub crawl", "display": "", "hideIf": [] },
   { "source": "Tours", "display": "", "hideIf": [] },
   { "source": "Wind surfing", "display": "", "hideIf": [] },
   { "source": "Anti-viral cleaning products", "display": "", "hideIf": [] },
   { "source": "Cashless payment service", "display": "", "hideIf": [] },
   { "source": "Doctor/nurse on call", "display": "", "hideIf": [] },
   { "source": "First aid kit", "display": "", "hideIf": [] },
   { "source": "Guest rooms seal after sanitization", "display": "", "hideIf": [] },
   { "source": "Hand sanitizer", "display": "", "hideIf": [] },
   { "source": "Hot water linen and laundry washing", "display": "", "hideIf": [] },
   { "source": "Individually-wrapped food options", "display": "", "hideIf": [] },
   { "source": "Professional-grade sanitizing services", "display": "", "hideIf": [] },
   { "source": "Rooms sanitized between stays", "display": "", "hideIf": [] },
   { "source": "Sanitized kitchen and tableware items", "display": "", "hideIf": [] },
   { "source": "Shared stationery removed", "display": "", "hideIf": [] },
   { "source": "Staff trained in safety protocol", "display": "", "hideIf": [] },
   { "source": "Temperature check for guests and staff", "display": "", "hideIf": [] },
   { "source": "Air conditioning in public area", "display": "", "hideIf": [] },
   { "source": "Contactless check-in/out", "display": "", "hideIf": [] },
   { "source": "Daily housekeeping", "display": "", "hideIf": [] },
   { "source": "Facilities for disabled guests", "display": "", "hideIf": [] },
   { "source": "Food delivery", "display": "", "hideIf": [] },
   { "source": "Heating in public area", "display": "", "hideIf": [] },
   { "source": "Invoice provided", "display": "", "hideIf": [] },
   { "source": "Luggage storage", "display": "", "hideIf": [] },
   { "source": "Meeting/banquet facilities", "display": "", "hideIf": [] },
   { "source": "Shared lounge/TV area", "display": "", "hideIf": [] },
   { "source": "Smoking area", "display": "", "hideIf": [] },
   { "source": "Terrace", "display": "", "hideIf": [] },
   { "source": "Family/child friendly", "display": "", "hideIf": [] },
   { "source": "Family room", "display": "", "hideIf": [] },
   { "source": "CCTV in common areas", "display": "", "hideIf": [] },
   { "source": "CCTV outside property", "display": "", "hideIf": [] },
   { "source": "Check-in/out [express]", "display": "", "hideIf": [] },
   { "source": "Check-in/out [private]", "display": "", "hideIf": [] },
   { "source": "Fire extinguisher", "display": "", "hideIf": [] },
   { "source": "Front desk [24-hour]", "display": "", "hideIf": [] },
   { "source": "Non-smoking rooms", "display": "", "hideIf": [] },
   { "source": "Safety/security feature", "display": "", "hideIf": [] },
   { "source": "Security [24-hour]", "display": "", "hideIf": [] },
   { "source": "Rental car", "display": "", "hideIf": [] },
   { "source": "Shower", "display": "", "hideIf": [] },
   { "source": "Toiletries", "display": "", "hideIf": [] },
   { "source": "Towels", "display": "", "hideIf": [] },
   { "source": "Ticket services", "display": "", "hideIf": [] },
   { "source": "Daily disinfection in all rooms", "display": "", "hideIf": [] },
   { "source": "Daily disinfection in common areas", "display": "", "hideIf": [] },
   { "source": "Face coverings on staff", "display": "", "hideIf": [] },
   { "source": "Free face masks", "display": "", "hideIf": [] },
   { "source": "Physical distancing of at least 1 meter", "display": "", "hideIf": [] },
   { "source": "Protective screens in common areas", "display": "", "hideIf": [] },
   { "source": "Currency exchange", "display": "", "hideIf": [] },
   { "source": "Elevator", "display": "", "hideIf": [] },
   { "source": "Smoke-free property", "display": "", "hideIf": [] },
   { "source": "Check-in [24-hour]", "display": "", "hideIf": [] },
   { "source": "Car park [nearby]", "display": "", "hideIf": [] },
   { "source": "On-site accessible restaurants / lounges", "display": "", "hideIf": [] },
   { "source": "Bottle of water", "display": "", "hideIf": [] },
   { "source": "Coffee/tea in restaurant", "display": "", "hideIf": [] },
   { "source": "Desserts in restaurant", "display": "", "hideIf": [] },
   { "source": "Doorman", "display": "", "hideIf": [] },
   { "source": "Ironing service", "display": "", "hideIf": [] },
   { "source": "Meetings", "display": "", "hideIf": [] },
   { "source": "Safety deposit boxes", "display": "", "hideIf": [] },
   { "source": "Wi-Fi for special events", "display": "", "hideIf": [] },
   { "source": "Couple's room", "display": "", "hideIf": [] },
   { "source": "Smoke alarms", "display": "", "hideIf": [] },
   { "source": "Soundproof rooms", "display": "", "hideIf": [] },
   { "source": "Balcony/terrace", "display": "", "hideIf": [] },
   { "source": "Coffee/tea maker", "display": "", "hideIf": [] },
   { "source": "Desk", "display": "", "hideIf": [] },
   { "source": "Ironing facilities", "display": "", "hideIf": [] },
   { "source": "Mirror", "display": "", "hideIf": [] },
   { "source": "Non-smoking", "display": "", "hideIf": [] },
   { "source": "Private bathroom", "display": "", "hideIf": [] },
   { "source": "Satellite/cable channels", "display": "", "hideIf": [] },
   { "source": "Seating area", "display": "", "hideIf": [] },
   { "source": "Telephone", "display": "", "hideIf": [] },
   { "source": "Kids meal", "display": "", "hideIf": [] },
   { "source": "Garden", "display": "", "hideIf": [] },
   { "source": "Hammam", "display": "", "hideIf": [] },
   { "source": "Snorkeling", "display": "", "hideIf": [] },
   { "source": "Room sanitization opt-out available", "display": "", "hideIf": [] },
   { "source": "Cash withdrawal", "display": "", "hideIf": [] },
   { "source": "Danish", "display": "", "hideIf": [] },
   { "source": "Norwegian", "display": "", "hideIf": [] },
   { "source": "Swedish", "display": "", "hideIf": [] },
   { "source": "Fitness center", "display": "", "hideIf": [] },
   { "source": "Breakfast in room", "display": "", "hideIf": [] },
   { "source": "Safe dining setup", "display": "", "hideIf": [] },
   { "source": "Alternative meal arrangement", "display": "", "hideIf": [] },
   { "source": "Dry cleaning", "display": "", "hideIf": [] },
   { "source": "Allergy-free rooms", "display": "", "hideIf": [] },
   { "source": "Accessible by elevator", "display": "", "hideIf": [] },
   { "source": "Additional toilet", "display": "", "hideIf": [] },
   { "source": "Air conditioning", "display": "", "hideIf": [] },
   { "source": "Alarm clock", "display": "", "hideIf": [] },
   { "source": "Alarm clock telephone ringer", "display": "", "hideIf": [] },
   { "source": "Baby cot (upon request)", "display": "", "hideIf": [] },
   { "source": "Clothes rack", "display": "", "hideIf": [] },
   { "source": "Hair dryer", "display": "", "hideIf": [] },
   { "source": "Hypoallergenic", "display": "", "hideIf": [] },
   { "source": "In-room safe box", "display": "", "hideIf": [] },
   { "source": "Interconnecting room(s) available", "display": "", "hideIf": [] },
   { "source": "Laptop safe box", "display": "", "hideIf": [] },
   { "source": "Linens", "display": "", "hideIf": [] },
   { "source": "Locker", "display": "", "hideIf": [] },
   { "source": "Mobility accessibility", "display": "", "hideIf": [] },
   { "source": "Radio", "display": "", "hideIf": [] },
   { "source": "Shower chair", "display": "", "hideIf": [] },
   { "source": "Sleep comfort items", "display": "", "hideIf": [] },
   { "source": "Smoke detector", "display": "", "hideIf": [] },
   { "source": "Socket near the bed", "display": "", "hideIf": [] },
   { "source": "Soundproofing", "display": "", "hideIf": [] },
   { "source": "Trash cans", "display": "", "hideIf": [] },
   { "source": "Wake-up service", "display": "", "hideIf": [] },
   { "source": "Walk-in shower", "display": "", "hideIf": [] },
   { "source": "Window", "display": "", "hideIf": [] },
   { "source": "Wooden/parqueted flooring", "display": "", "hideIf": [] },
   { "source": "Catalan", "display": "", "hideIf": [] },
   { "source": "Hindi", "display": "", "hideIf": [] },
   { "source": "Buzzer/wireless intercom", "display": "", "hideIf": [] },
   { "source": "Fan", "display": "", "hideIf": [] },
   { "source": "TV", "display": "", "hideIf": [] },
   { "source": "Tamil", "display": "", "hideIf": [] },
   { "source": "Bicycles", "display": "", "hideIf": [] },
   { "source": "Boating", "display": "", "hideIf": [] },
   { "source": "Table tennis", "display": "", "hideIf": [] },
   { "source": "Lockers", "display": "", "hideIf": [] },
   { "source": "Exterior corridor", "display": "", "hideIf": [] },
   { "source": "Bicycle parking", "display": "", "hideIf": [] },
   { "source": "TV [flat screen]", "display": "", "hideIf": [] },
   { "source": "French", "display": "", "hideIf": [] },
   { "source": "Japanese", "display": "", "hideIf": [] },
   { "source": "Golf course [on-site]", "display": "", "hideIf": [] },
   { "source": "Body thermometer", "display": "", "hideIf": [] },
   { "source": "Breakfast takeaway service", "display": "", "hideIf": [] },
   { "source": "Pet-sitting services", "display": "", "hideIf": [] },
   { "source": "Nepali", "display": "", "hideIf": [] },
   { "source": "Business facilities", "display": "", "hideIf": [] },
   { "source": "Rooftop area", "display": "", "hideIf": [] },
   { "source": "Hotel room service app", "display": "", "hideIf": [] },
   { "source": "Hygiene certification", "display": "", "hideIf": [] },
   { "source": "Beam projector", "display": "", "hideIf": [] },
   { "source": "On-site event hosting", "display": "", "hideIf": [] },
   { "source": "Kids shampoo", "display": "", "hideIf": [] },
   { "source": "Kids toothbrush", "display": "", "hideIf": [] },
   { "source": "Hotel chain", "display": "", "hideIf": [] },
   { "source": "Litter boxes", "display": "", "hideIf": [] },
   { "source": "Room decorations", "display": "", "hideIf": [] },
   { "source": "Taxi service", "display": "", "hideIf": [] },
   { "source": "Halal breakfast", "display": "", "hideIf": [] },
   { "source": "Turkish", "display": "", "hideIf": [] },
   { "source": "Wi-Fi [portable rental]", "display": "", "hideIf": [] },
   { "source": "Body wrap", "display": "", "hideIf": [] },
   { "source": "Glamping", "display": "", "hideIf": [] },
   { "source": "Light therapy", "display": "", "hideIf": [] },
   { "source": "Outdoor recreational features", "display": "", "hideIf": [] },
   { "source": "Private bath", "display": "", "hideIf": [] },
   { "source": "Fruits/snacks", "display": "", "hideIf": [] },
   { "source": "Postal service", "display": "", "hideIf": [] },
   { "source": "Baby changing rooms", "display": "", "hideIf": [] },
   { "source": "Babysitting service", "display": "", "hideIf": [] },
   { "source": "Mirrored room", "display": "", "hideIf": [] },
   { "source": "Proposal spot", "display": "", "hideIf": [] },
   { "source": "Service animals are welcome", "display": "", "hideIf": [] },
   { "source": "Themed rooms", "display": "", "hideIf": [] },
   { "source": "Bathrobes", "display": "", "hideIf": [] },
   { "source": "Free instant coffee", "display": "", "hideIf": [] },
   { "source": "Heating", "display": "", "hideIf": [] },
   { "source": "Kettle", "display": "", "hideIf": [] },
   { "source": "Sofa", "display": "", "hideIf": [] },
   { "source": "Horseback riding", "display": "", "hideIf": [] },
   { "source": "Skiing", "display": "", "hideIf": [] },
   { "source": "Fireplace", "display": "", "hideIf": [] },
   { "source": "Laundromat", "display": "", "hideIf": [] },
   { "source": "Library", "display": "", "hideIf": [] },
   { "source": "Bicycle rental", "display": "", "hideIf": [] },
   { "source": "Thai", "display": "", "hideIf": [] },
   { "source": "Closet", "display": "", "hideIf": [] },
   { "source": "Refrigerator", "display": "", "hideIf": [] },
   { "source": "Vending machine", "display": "", "hideIf": [] },
   { "source": "Convenience store", "display": "", "hideIf": [] },
   { "source": "Shrine", "display": "", "hideIf": [] },
   { "source": "Adapter", "display": "", "hideIf": [] },
   { "source": "Cleaning products", "display": "", "hideIf": [] },
   { "source": "Electric kettle", "display": "", "hideIf": [] },
   { "source": "Individual air conditioning", "display": "", "hideIf": [] },
   { "source": "Slippers", "display": "", "hideIf": [] },
   { "source": "Arabic", "display": "", "hideIf": [] },
   { "source": "Russian", "display": "", "hideIf": [] },
   { "source": "Billiards", "display": "", "hideIf": [] },
   { "source": "Body scrub", "display": "", "hideIf": [] },
   { "source": "Dart board", "display": "", "hideIf": [] },
   { "source": "Water sports (non-motorized)", "display": "", "hideIf": [] },
   { "source": "Sterilizing equipment", "display": "", "hideIf": [] },
   { "source": "Grocery delivery", "display": "", "hideIf": [] },
   { "source": "Salon", "display": "", "hideIf": [] },
   { "source": "Mini bar", "display": "", "hideIf": [] },
   { "source": "German", "display": "", "hideIf": [] },
   { "source": "Kitchen", "display": "", "hideIf": [] },
   { "source": "Audio-visual equipment for special events", "display": "", "hideIf": [] },
   { "source": "Meeting stationery", "display": "", "hideIf": [] },
   { "source": "Step stool", "display": "", "hideIf": [] },
   { "source": "pet bowls", "display": "", "hideIf": [] },
   { "source": "Pets may not be left unattended", "display": "", "hideIf": [] },
   { "source": "Car power charging station", "display": "", "hideIf": [] },
   { "source": "Accessible by stairs", "display": "", "hideIf": [] },
   { "source": "Audible alarm", "display": "", "hideIf": [] },
   { "source": "Blackout curtains", "display": "", "hideIf": [] },
   { "source": "Low floor available", "display": "", "hideIf": [] },
   { "source": "Openable window", "display": "", "hideIf": [] },
   { "source": "Streaming service like Netflix", "display": "", "hideIf": [] },
   { "source": "Window that opens", "display": "", "hideIf": [] },
   { "source": "Chinese [Mandarin]", "display": "", "hideIf": [] },
   { "source": "Additional bathroom", "display": "", "hideIf": [] },
   { "source": "Complimentary tea", "display": "", "hideIf": [] },
   { "source": "Extra long bed", "display": "", "hideIf": [] },
   { "source": "Separate living room", "display": "", "hideIf": [] },
   { "source": "Reading light", "display": "", "hideIf": [] },
   { "source": "Indonesian", "display": "", "hideIf": [] },
   { "source": "Korean", "display": "", "hideIf": [] },
   { "source": "Massage chair", "display": "", "hideIf": [] },
   { "source": "Braille and tactile signage", "display": "", "hideIf": [] },
   { "source": "Dishwasher", "display": "", "hideIf": [] },
   { "source": "Microwave", "display": "", "hideIf": [] },
   { "source": "Full kitchen", "display": "", "hideIf": [] },
   { "source": "Kitchenette", "display": "", "hideIf": [] },
   { "source": "Greek", "display": "", "hideIf": [] },
   { "source": "Foot bath", "display": "", "hideIf": [] },
   { "source": "Nightclub", "display": "", "hideIf": [] },
   { "source": "Covid-19 testing service", "display": "", "hideIf": [] },
   { "source": "Western cuisine in restaurant", "display": "", "hideIf": [] },
   { "source": "Grooming service", "display": "", "hideIf": [] },
   { "source": "Indoor venue for special events", "display": "", "hideIf": [] },
   { "source": "Projector/LED display", "display": "", "hideIf": [] },
   { "source": "Seminars", "display": "", "hideIf": [] },
   { "source": "Pet facilities", "display": "", "hideIf": [] },
   { "source": "Access all room by interior corridor", "display": "", "hideIf": [] },
   { "source": "Tile/marble flooring", "display": "", "hideIf": [] },
   { "source": "TV [in bathroom]", "display": "", "hideIf": [] },
   { "source": "Private BBQ facilities", "display": "", "hideIf": [] },
   { "source": "Chinese cuisine in restaurant", "display": "", "hideIf": [] },
   { "source": "Essential condiments", "display": "", "hideIf": [] },
   { "source": "Outdoor venue for special events", "display": "", "hideIf": [] },
   { "source": "Couples only", "display": "", "hideIf": [] },
   { "source": "Asian breakfast", "display": "", "hideIf": [] },
   { "source": "Croatian", "display": "", "hideIf": [] },
   { "source": "Ukrainian", "display": "", "hideIf": [] },
   { "source": "International cuisine in restaurant", "display": "", "hideIf": [] },
   { "source": "Air purifier", "display": "", "hideIf": [] },
   { "source": "Carpeting", "display": "", "hideIf": [] },
   { "source": "Shared bathroom", "display": "", "hideIf": [] },
   { "source": "Tennis court", "display": "", "hideIf": [] },
   { "source": "Separate dining area", "display": "", "hideIf": [] },
   { "source": "Wine glasses", "display": "", "hideIf": [] },
   { "source": "Kids facilities", "display": "", "hideIf": [] },
   { "source": "Kids safety features", "display": "", "hideIf": [] },
   { "source": "Duplex room", "display": "", "hideIf": [] },
   { "source": "Entire home", "display": "", "hideIf": [] },
   { "source": "Filming locations", "display": "", "hideIf": [] },
   { "source": "Smoking allowed", "display": "", "hideIf": [] },
   { "source": "Burmese", "display": "", "hideIf": [] },
   { "source": "Chinese [Cantonese]", "display": "", "hideIf": [] },
   { "source": "Activity Kits", "display": "", "hideIf": [] },
   { "source": "Solarium", "display": "", "hideIf": [] },
   { "source": "Infirmary", "display": "", "hideIf": [] },
   { "source": "Accessible vanities", "display": "", "hideIf": [] },
   { "source": "Baby amenities (upon request)", "display": "", "hideIf": [] },
   { "source": "Baby safety gates", "display": "", "hideIf": [] },
   { "source": "Board games/puzzles", "display": "", "hideIf": [] },
   { "source": "Books/DVDs/music for children", "display": "", "hideIf": [] },
   { "source": "Carbon monoxide detector", "display": "", "hideIf": [] },
   { "source": "Dressing room", "display": "", "hideIf": [] },
   { "source": "iPod docking station", "display": "", "hideIf": [] },
   { "source": "Outdoor furniture", "display": "", "hideIf": [] },
   { "source": "Private entrance", "display": "", "hideIf": [] },
   { "source": "Private pool", "display": "", "hideIf": [] },
   { "source": "Roll-in shower", "display": "", "hideIf": [] },
   { "source": "Trouser press", "display": "", "hideIf": [] },
   { "source": "Washing machine", "display": "", "hideIf": [] },
   { "source": "Jokgu field", "display": "", "hideIf": [] },
   { "source": "Korean sauna", "display": "", "hideIf": [] },
   { "source": "Massage bed", "display": "", "hideIf": [] },
   { "source": "Vegetarian restaurant", "display": "", "hideIf": [] },
   { "source": "Chapel", "display": "", "hideIf": [] },
   { "source": "Kids cutlery", "display": "", "hideIf": [] },
   { "source": "Café design room", "display": "", "hideIf": [] },
   { "source": "Accessible toilet", "display": "", "hideIf": [] },
   { "source": "Adapted bath", "display": "", "hideIf": [] },
   { "source": "Clothes dryer", "display": "", "hideIf": [] },
   { "source": "Daily newspaper", "display": "", "hideIf": [] },
   { "source": "Dining table", "display": "", "hideIf": [] },
   { "source": "High chair", "display": "", "hideIf": [] },
   { "source": "High floor", "display": "", "hideIf": [] },
   { "source": "In-room tablet", "display": "", "hideIf": [] },
   { "source": "Lever handle on door", "display": "", "hideIf": [] },
   { "source": "Lowered view port in door", "display": "", "hideIf": [] },
   { "source": "Mosquito net", "display": "", "hideIf": [] },
   { "source": "Open air bath privileges", "display": "", "hideIf": [] },
   { "source": "Scale", "display": "", "hideIf": [] },
   { "source": "Self-closing door", "display": "", "hideIf": [] },
   { "source": "Umbrella", "display": "", "hideIf": [] },
   { "source": "Visual alarm", "display": "", "hideIf": [] },
   { "source": "Vietnamese", "display": "", "hideIf": [] },
   { "source": "Off-leash areas", "display": "", "hideIf": [] },
   { "source": "Kitchenware", "display": "", "hideIf": [] },
   { "source": "Romanian", "display": "", "hideIf": [] },
   { "source": "Laptop/PC rental", "display": "", "hideIf": [] },
   { "source": "Surfing lessons", "display": "", "hideIf": [] },
   { "source": "Filipino", "display": "", "hideIf": [] },
   { "source": "Lao", "display": "", "hideIf": [] },
   { "source": "Mobile hotspot device", "display": "", "hideIf": [] },
   { "source": "Electric blanket", "display": "", "hideIf": [] },
   { "source": "Bathtub", "display": "", "hideIf": [] },
   { "source": "Laptop workspace", "display": "", "hideIf": [] },
   { "source": "Malay", "display": "", "hideIf": [] },
   { "source": "Lithuanian", "display": "", "hideIf": [] },
   { "source": "On-demand movies", "display": "", "hideIf": [] },
   { "source": "Ground floor available", "display": "", "hideIf": [] },
   { "source": "Private apartment in building", "display": "", "hideIf": [] },
   { "source": "Top floor available", "display": "", "hideIf": [] },
   { "source": "Czech", "display": "", "hideIf": [] },
   { "source": "Dutch", "display": "", "hideIf": [] },
   { "source": "Computer", "display": "", "hideIf": [] },
   { "source": "In-room computer", "display": "", "hideIf": [] },
   { "source": "Sinhala", "display": "", "hideIf": [] },
   { "source": "Party design room", "display": "", "hideIf": [] },
   { "source": "Women-only property", "display": "", "hideIf": [] },
   { "source": "Shoeshine kit", "display": "", "hideIf": [] },
   { "source": "Ski equipment rentals", "display": "", "hideIf": [] },
   { "source": "Body wash", "display": "", "hideIf": [] },
   { "source": "Hand sanitizer and soap provided", "display": "", "hideIf": [] }
]
